export const truncateFilename = (name: string, maxLength = 20) => {
    if (name.length <= maxLength) return name;

    const dotIndex = name.lastIndexOf('.');
    const hasExt   = dotIndex > 0 && dotIndex > name.length - 8;

    if (!hasExt) return `${ name.slice(0, maxLength - 1) }…`;

    const ext  = name.slice(dotIndex);
    const base = name.slice(0, dotIndex);
    const keep = maxLength - ext.length - 1;

    if (keep <= 0) return `${ base.slice(0, 1) }…${ ext }`;

    return `${ base.slice(0, keep) }…${ ext }`;
};
